import {AbstractAsset} from './abstract-asset';
import {AssetKind} from './asset-kind.enum';

export class HomeAsset extends AbstractAsset {
    mq: number;
    mqValue: number;
    rebuildValue: number;

    constructor() {
          super(AssetKind.HOME);
    }
}
